/** @format */

import React, { useState, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { createFilterOptions } from '@mui/material/useAutocomplete';
import { TextField } from '@mui/material';
import findIndex from 'lodash/findIndex';
import TagServices from './services/TagServices';

const filter = createFilterOptions();

const Tag = (props) => {
  const { categoryTagName, errors, control, label, rules, setTagCat = '', ...rest } = props;

  const [tagList, setTagList] = useState([]);

  useEffect(() => {
    const param = { name: categoryTagName };
    const services = new TagServices();

    (async () => {
      try {
        const data = await services.getTagTreeCategoryList(param);
        if (data.result.length > 0) {
          if (setTagCat) {
            setTagCat(data.result[0].id);
          }
          getTagTreeList(data.result[0].id);
          return;
        }

        addTagTreeCategory(param);
      } catch (error) {}
    })();

    async function addTagTreeCategory() {
      try {
        const data = await services.addTagTreeCategory(param);

        if (setTagCat) {
          setTagCat(data.result.id);
        }
      } catch (error) {}
    }

    async function getTagTreeList(categoryId) {
      try {
        const param = { categoryId, levelCount: 1, level: 0 };
        const data = await services.getTagTreeList(param);

        if (data.result.length > 0) {
          const list = [];
          data.result.map((item) => list.push({ name: item.name, code: item.code, isNew: false }));
          setTagList(list);
        }
      } catch (error) {}
    }
  }, [categoryTagName, setTagCat]);

  const checkItemExist = (obj, val) => {
    return findIndex(obj, ['name', val]);
  };

  return (
    <Controller
      name="tags"
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          {...rest}
          // onKeyPressCapture={handleKeyPress}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          // onChange={(event, newValue) => {
          //   onChange(newValue);
          // }}
          onChange={(event, newValue) => {
            const val = newValue[newValue.length - 1];
            const lngVal = newValue.length - 1;
            if (typeof val === 'string') {
              if (checkItemExist(newValue, val) < 0) {
                newValue[lngVal] = {
                  name: val,
                  code: val,
                  new: true,
                };

                onChange(newValue);
              }
            } else if (val && val.inputValue) {
              if (checkItemExist(newValue, val.inputValue) < 0) {
                newValue[lngVal] = {
                  name: val.inputValue,
                  code: val.inputValue,
                  isNew: 'true',
                };

                onChange(newValue);
              }
            } else {
              onChange(newValue);
            }
          }}
          value={value}
          multiple
          id="tags"
          isOptionEqualToValue={(option, value) => option.name === value.name}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }
            // Regular option
            return option.name;
          }}
          options={tagList}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);

            // Suggest the creation of a new value
            if (params.inputValue !== '') {
              filtered.push({
                inputValue: params.inputValue,
                name: `افزودن "${params.inputValue}"`,
              });
            }

            return filtered;
          }}
          renderOption={(optionProps, option) => <li {...optionProps}>{option.name}</li>}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              error={!!errors?.tags}
              helperText={errors?.tags?.message}
              variant="outlined"
              label={label}
            />
          )}
          freeSolo
        />
      )}
      defaultValue={[]}
      control={control}
      // rules={{
      //   required: "فیلد تگ الزامی است.",
      // }}
    />
  );
};

export default Tag;
